export default "__VITE_ASSET__j1L74jeX__"